
import { defineComponent } from 'vue';
import SearchModal from '@/components/widgets/SearchModal.vue'

export default defineComponent({
    emits: [
        'click:ok',
        'click:cancel',
    ],
    components: {
        SearchModal
    },
    async mounted() {
    
    },
    props: {
        display: {
            type: Boolean,
            default: false
        },
        primaryKey: {
            type: String,
            default: "ServiceAgreementID" 
        },
        excludedKeys: {
            type: Array,
            default: () => ['ServiceAgreementID']
        },
        searchPath: {
            type: String,
            default: 'service-agreement/search'
        },
        text: {
            type: String,
            default: 'Søg efter service kontrakt'
        },
        title: {
            type: String,
            default: 'Find Kontrakt'
        },
        enableX: {
            type: Boolean,
            default: false
        },
        okBtn: {
            type: String,
            default: 'Vælg'
        },
        cancelBtn: {
            type: String,
            default: 'Fortryd'
        },
    },
    methods: {
        ok(customer: any) { 
            this.$emit('click:ok', customer);
        },
        cancel() { 
            this.$emit('click:cancel');    
        }
    },
});
